const styleSheet = () => ({
  actionButtons: {
    paddingTop: '15px',
    marginLeft: '17px',
  },
});

export default styleSheet;
